// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.5
//   protoc               v6.30.2
// source: account.proto

/* eslint-disable */
import type { Empty } from "./google/protobuf/empty";
import type { Struct } from "./google/protobuf/struct";

export const protobufPackage = "proto";

export enum ConsentState {
  /** DEFAULT - default state. OpenAI categories are shown but not processed by Toru. */
  DEFAULT = "DEFAULT",
  /** APPROVED - Consent given state. OpenAI categories are shown and processed by Toru. */
  APPROVED = "APPROVED",
  /** REJECTED - Consent removed state. OpenAI categories are hidden and not processed by Toru. */
  REJECTED = "REJECTED",
}

export interface Consents {
  azureOpenAiConsentState?: ConsentState | undefined;
  skipAutoQaCategoryCheck: boolean;
  openAiConsentState?: ConsentState | undefined;
}

export interface PraiseBotSettings {
  enabled: boolean;
  channelName?: string | undefined;
  channelId?: string | undefined;
  commentedFeedbackOnly: boolean;
}

export interface AutoQaSettings {
  autoQaEnabled: boolean;
}

export interface AnonymizationSettings {
  anonymizationEnabled: boolean;
}

export interface Account {
  GetConsents(request: Empty): Promise<Consents>;
  SetConsents(request: Consents): Promise<Consents>;
  GetPraiseBotSettings(request: Empty): Promise<PraiseBotSettings>;
  SetPraiseBotSettings(request: PraiseBotSettings): Promise<PraiseBotSettings>;
  ReceiveZendeskAccountWebhook(request: Struct): Promise<Empty>;
  ReceiveZendeskUsersWebhook(request: Struct): Promise<Empty>;
  SetAutoQaSettings(request: AutoQaSettings): Promise<AutoQaSettings>;
  GetAutoQaSettings(request: Empty): Promise<AutoQaSettings>;
  GetSuncoZ2Jwt(request: Empty): Promise<Struct>;
  SetAnonymizationSettings(request: AnonymizationSettings): Promise<AnonymizationSettings>;
  GetAnonymizationSettings(request: Empty): Promise<AnonymizationSettings>;
}
